<div class="page gray-font-color font-family">
  <div class="header-navigation-back">
    <div class="back-icon" (click)="backAction()" data-test="back-arrow-button" data-testid="back-arrow-button">
      <mat-icon svgIcon="left-arrow"></mat-icon>
    </div>
    <div class="header-text">Employement History Check</div>
  </div>
  <div class="content">
    <h2 class="title">Consent for Employment Verification</h2>
    <p class="message">
      I {{ driverDetails.firstName }} {{ driverDetails.lastName }} hereby authorize you to release the following
      information to {{ dqfData.carrierCompanyName }} for the purposes of investigation as required by Section 391.23
      and allowed by section 383.35 of the Federal Motor Carrier Safety Regulations. You are released from all liability
      which may result from furnishing such information.
    </p>
    <p class="subnote">
      I understand that my signature below grants {{ dqfData.carrierCompanyName }} permission to request and receive
      this information and releases the previous employer from any liability resulting from the disclosure of such
      information.
    </p>

    <div class="canvas-container">
      <canvas #signatureCanvas class="signature-box" data-testid="employment-signature-canvas"></canvas>
    </div>
    <p class="canvas-subnote">Please sign within the box</p>

    <div class="place-form-container">
      <mat-form-field appearance="outline" class="place-field">
        <mat-label>Place</mat-label>
        <input matInput [(ngModel)]="place" placeholder="Enter place" required data-testid="employment-signature-place">
        <mat-error *ngIf="!place && formSubmitted">Place is required</mat-error>
      </mat-form-field>
    </div>

    <div class="actions">
        <button mat-stroked-button class="clear" (click)="clearSignature()" [disabled]="isLoading" data-testid="employment-signature-clear">Clear</button>
        <button mat-raised-button color="primary" (click)="saveSignature()" [disabled]="!hasSignature || !place?.trim() || isLoading" class="save-button" data-testid="employment-signature-save">
          @if (isLoading) {
            <mat-spinner diameter="18"></mat-spinner>
          }
          <span [class.loading-text]="isLoading">
            {{ isLoading ? 'Saving...' : !hasSignature ? 'Please sign above to enable save' : !place?.trim() ? 'Please enter place to enable save' : 'Save' }}
          </span>
        </button>
    </div>
  </div>
</div>